import { render, staticRenderFns } from "./modal_revisit.vue?vue&type=template&id=38227822&scoped=true&"
import script from "./modal_revisit.vue?vue&type=script&lang=js&"
export * from "./modal_revisit.vue?vue&type=script&lang=js&"
import style0 from "./modal_revisit.vue?vue&type=style&index=0&id=38227822&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38227822",
  null
  
)

export default component.exports